import React, { useState, useEffect } from "react";
import styled from "styled-components";
import * as moment from "moment";
import { TextField, Button } from "@material-ui/core";
import DatePicker from "react-datepicker";
import Switch from "react-switch";

export default function ViewJobOrder(props) {
  return (
    <>
      <Section>
        <div className="view__acc_container">
          <div className="view__filterbox__container">
            <div className="view__filterdate__container">
              <div style={{ marginTop: "-0.5rem" }}>
                <DatePicker
                  value={
                    props.from_date !== "Invalid date" ? props.from_date : ""
                  }
                  onChange={(date) => {
                    props.onHandleFromDate(date);
                  }}
                  dateFormat="yyyy-MM-dd"
                  placeholderText="From (Bill Date)"
                  monthsShown={1}
                  showYearDropdown
                />
              </div>

              <div style={{ marginTop: "-0.5rem" }}>
                <DatePicker
                  value={props.to_date !== "Invalid date" ? props.to_date : ""}
                  onChange={(date) => {
                    props.onHandleToDate(date);
                  }}
                  dateFormat="yyyy-MM-dd"
                  placeholderText="To (Bill Date)"
                  monthsShown={1}
                  showYearDropdown
                />
              </div>

              <div>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    props.onHandleSearchDate();
                  }}
                >
                  <i className="fa fa-search"></i>{" "}
                </Button>
              </div>

              <div>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    props.onBillFetch();
                  }}
                >
                  {" "}
                  Print{" "}
                </Button>
              </div>
            </div>

            <div className="view__filtersearch__container">
              <TextField
                className="txtfld"
                id="outlined-basic"
                variant="outlined"
                fullWidth={false}
                onChange={(e) => {
                  props.onHandleSearch(e.target.value);
                }}
                value={props.search}
                placeholder="Search"
                style={{ backgroundColor: "white" }}
              />
            </div>
          </div>
          <h1>Bill (Products)</h1>
          <div
            className="table-responsive"
            style={{ marginTop: "-0.1rem", overflow: "auto", height: "500px" }}
          >
            <table className="table table-bordered table-responsive-sm">
              <thead style={{ backgroundColor: "#f0932b", color: "#ffffff" }}>
                <tr>
                  <th>S.No</th>
                  <th>OrderDate</th>
                  <th>Fitter Name</th>
                  <th>JobOrder Number</th>
                  <th>Brand</th>
                  <th>Frame</th>
                  <th>Model Number</th>
                  <th>Frame Color</th>
                  <th>Frame Size</th>
                  <th>Lens</th>
                  <th>LensPower</th>
                  <th>DeliverDate</th>
                  <th></th>
                </tr>
              </thead>
              <tbody
                style={{ maxHeight: "200px", overflowY: "auto", width: "100%" }}
              >
                {props.joborder.length > 0 ? (
                  props.joborder.map((job, index) => {
                    return (
                      <tr
                        key={index}
                        onClick={() => {
                          props.onHandleEditChange(job);
                        }}
                      >
                        <>
                          <td> {index + 1} </td>
                          <td>
                            {" "}
                            {moment(job.order_date).format("DD-MM-YYYY")}{" "}
                          </td>
                          <td> {job.fitter_name} </td>
                          <td> {job.job_order_number} </td>
                          <td> {job.brand} </td>
                          <td> {job.frame} </td>
                          <td>{job.model_number}</td>
                          <td> {job.frame_color} </td>
                          <td> {job.frame_size} </td>
                          <td> {job.lens} </td>
                          <td> {job.lens_power} </td>
                          <td>
                            {moment(job.deliver_date).format("DD-MM-YYYY")}{" "}
                          </td>
                        </>
                        {/* <td>
                          <Switch
                            onChange={(val) => {
                              props.onHandleSwitchChange(job, val);
                            }}
                            checked={job.bill_checked === 1 ? true : false}
                          />
                        </td> */}
                        <td
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            props.onHandleDelete(job);
                          }}
                        >
                          <i className="fa fa-trash"></i>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td>No Data</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </Section>
    </>
  );
}

const Section = styled.section`
  .view__acc_container {
    margin: 0px 50px;
  }

  .view__filterbox__container {
    margin: 20px auto;
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    background-color: #ffbe76;
  }
  .view__filterdate__container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    flex: 0.7;
  }
  .view__filtersearch__container {
    flex: 0.3;
    text-align: center;
  }

  @media screen and (min-width: 280px) and (max-width: 720px) {
    .view__filterbox__container {
      display: flex;
      flex-direction: column;
    }
    .view__filterdate__container {
      display: flex;
      flex-direction: column;
    }
  }
`;
